import script from "./HeroCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroCarousel.vue?vue&type=script&setup=true&lang=js"

import "./HeroCarousel.vue?vue&type=style&index=0&id=12d306c8&lang=scss"

const __exports__ = script;

export default __exports__